import React from 'react';
import {
    Box,
    SimpleGrid,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Heading,
    Text,
    Button,
    Image,
    useColorModeValue,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const services = [
    {
        title: "Renew your Driving Licence Card",
        description: "Book now to renew your Driving Licence Card",
        image:
            "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=800&q=80",
        link: "/buses",
    },
    {
        title: "Id Appliaction",
        description: "Apply for your National Id",
        image:
            "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=800&q=80",
        link: "/buses",
    },
    {
        title: "Passport Application",
        description: "Apply for your Passport",
        image:
            "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=800&q=80",
        link: "/buses",
    },
    {
        title: "Book now for Learner's Licence Test",
        description: "Book now for Learner's Licence Test",
        image:
            "https://images.pexels.com/photos/358319/pexels-photo-358319.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        link: "/flights",
    },
    {
        title: "Book now for Driving Licence Test",
        description: "Drive around in style with our car rental service.",
        image:
            "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?auto=format&fit=crop&w=800&q=80",
        link: "/cars",
    },
    {
        title: "Book now for PrDP Application",
        description: "Book cozy and affordable places to stay.",
        image:
            "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=800&q=80",
        link: "/accommodations",
    },
    {
        title: "Report a Motor Vehicle Crash (Damage Only)",
        description: "Report an accident",
        image:
            "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=800&q=80",
        link: "/accommodations",
    },
];

const Licences = () => {
    const navigate = useNavigate();
    const bg = useColorModeValue('white', 'gray.700');

    return (
        <Box>
            <SimpleGrid columns={{ base: 1, sm: 2, md: 2, lg: 4 }} spacing={6}>
                {services.map((service) => (
                    <Card
                        key={service.title}
                        bg={bg}
                        boxShadow="md"
                        borderRadius="md"
                        overflow="hidden"
                        cursor="pointer"
                        onClick={() => navigate(service.link)}
                        _hover={{ boxShadow: 'xl', transform: 'scale(1.02)', transition: '0.3s' }}
                    >
                        <Image src={service.image} alt={service.title} objectFit="cover" height="200px" width="100%" />
                        <CardHeader p={4}>
                            <Heading size="md">{service.title}</Heading>
                        </CardHeader>
                        <CardBody p={4}>
                            <Text>{service.description}</Text>
                        </CardBody>
                        <CardFooter p={4}>
                            <Button borderRadius={'4px'} colorScheme="teal" onClick={() => navigate(service.link)}>
                                Explore
                            </Button>
                        </CardFooter>
                    </Card>
                ))}
            </SimpleGrid>
        </Box>
    );
};

export default Licences;
